import {
  Box,
  Button,
  Grid,
  IconButton,
  ListItem,
  MenuItem,
  Typography,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import React, { useEffect, useState, useRef, useId } from "react";
import { BiMenu } from "react-icons/bi";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { FaChevronDown } from "react-icons/fa";
import { GrLanguage } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import arrow from "../images/arrow_btn.svg";
import vitta_logo from "../images/vittaLogo.svg";
import { styles, webStyle } from "../style/Header.style";
import { useTranslation } from "react-i18next";
import i18n from "../i18n.js";
import i18next from "i18next";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <FaChevronDown className="fachevroDownStyle" />
    </components.DropdownIndicator>
  );
};

const Header = ({ headerRef, headerHeight = 0 }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dropdownRef = useRef(null);
  const [bgColor, setBgColor] = useState("transparent");
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [headerMenu, setHeaderMenu] = React.useState(null);
  const [headerMenu2, setHeaderMenu2] = React.useState(null);
  const [headerMenu1, setHeaderMenu1] = React.useState(null);
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [lngValue, setLngValue] = useState(
    localStorage.getItem("language") || "en"
  );
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const styles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: bgColor,
      color: "#FFF",
      border: "1px solid lightgray",
      ":hover": {
        border: "1px solid darkgray",
        cursor: "pointer",
      },
      minHeight: screenWidth < 1200 ? "33px" : "38px",
      height: "30px",
      boxShadow: "none",
      transition: "none",
      padding: "0px",
      boederRadius: "20px",
      fontSize: "16px",
      width: "110px",
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#367CFF" : "whitesmoke",
      color: isSelected ? "#FFFFFF" : "#000000",
      zIndex: 1,
      ":hover": {
        backgroundColor: isSelected ? "#367CFF" : "lightgray",
        cursor: "pointer",
      },
      borderBottom: "1px solid #ffffff1e", // Change yourNewColor to the desired border color
      transition: "none",
      paddingTop: "5px",
      paddingBottom: "5px",
    }),
    // ... (rest of the styles)
    menu: (base) => ({
      ...base,
      zIndex: 1000,
      backgroundColor: "whitesmoke",
      marginTop: "0px",
      paddingTop: "0px",
      borderTopRightRadius: "0px",
      borderTopLeftRadius: "0px",
      borderBottom: "0px solid #ffffff1e",
      borderLeft: "1px solid #ffffff1e",
      borderRight: "1px solid #ffffff1e",
    }),
    menuList: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: "#A6A6A6",
    }),
    dropdownIndicator: (defaultStyles, state) => {
      return {
        ...defaultStyles,
        paddingLeft: state.selectProps.menuIsOpen ? "8px" : "0px",
        paddingRight: state.selectProps.menuIsOpen ? "0px" : "8px",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      };
    },
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const navLinkItem = [
    // {
    //     menu: [
    //         {
    //             name: 'Overview',
    //             routerPath: '/',
    //             subMenu: [
    //                 {
    //                     name: "Column 1",

    //                 }
    //             ]
    //         },
    //         {
    //             name: 'Solutions-solutions',
    //             routerPath: '/solutions'
    //         },
    //         {
    //             name: 'Smart Contract Auditing ',
    //             routerPath: '/auditing'
    //         },

    //         {
    //             name: ' Penetration Testing',
    //             routerPath: '/penetration'
    //         },
    //     ],
    //     routerPath: '/solutions',
    //     headerTitle: 'Solutions'
    // },
    {
      routerPath: "/our-services",
      headerTitle: t("services"),
    },
    {
      routerPath: "/resources",
      headerTitle: t("resources"),
    },
    {
      routerPath: "/team",
      headerTitle: t("team"),
    },
    {
      routerPath: "/contact-us",
      headerTitle: t("contact_us"),
    },
    // {
    //     routerPath: '/hackers',
    //     headerTitle: 'For Hackers',

    // },

    // {
    //     routerPath: '/community ',
    //     headerTitle: 'Community'
    // },
    // {
    //     routerPath: 'https://securr.gitbook.io/securr/',
    //     headerTitle: 'Docs'
    // },
  ];

  const languages = [
    {
      value: "en",
      label: "EN",
    },
    {
      value: "de",
      label: "DE",
    },
    {
      value: "fr",
      label: "FR",
    },
  ];

  const links = [
    {
      name: t("solutions"),
      link: "/solutions",
      submenu: true,
      sublinks: [
        {
          Head: t("platform"),
          sublink: [
            {
              name: t("omni_platform"),
              link: "/solutions#Platform",
              scrollId: "Platform",
            },
            {
              name: t("omni_ai_platform"),
              link: "/solutions#OmniAiChatbot",
              scrollId: "OmniAiChatbot",
            },
          ],
        },
        {
          Head: t("reporting"),
          sublink: [
            { name: t("ifrs9"), link: "/solutions#Ifrs9", scrollId: "Ifrs9" },
            { name: t("basel"), link: "/solutions#Basel3", scrollId: "Basel3" },
            {
              name: t("business_performance"),
              link: "/solutions#BusinessPerformance",
              scrollId: "BusinessPerformance",
            },
            { name: t("esg"), link: "/solutions#Esg", scrollId: "Esg" },
          ],
        },
        {
          Head: t("data_warehousing"),
          sublink: [
            {
              name: t("financial_data"),
              link: "/solutions#FinancialData",
              scrollId: "FinancialData",
            },
            {
              name: t("risk_data"),
              link: "/solutions#RiskData",
              scrollId: "RiskData",
            },
            {
              name: t("esg_data"),
              link: "/solutions#ESGData",
              scrollId: "ESGData",
            },
          ],
        },
      ],
    },
  ];

  const DropdownMenuItem = ({ menuItem, onClick }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const { routerPath, headerTitle, menu } = menuItem;

    const options = navLinkItem.flatMap(
      (item) =>
        item.menu &&
        item.menu.map((menuItem, i) => ({
          value: menuItem.routerPath,
          label: menuItem.name,
        }))
    );

    const lastOptions = options.filter((item) => item !== undefined);

    const navigate = useNavigate();
    const handleOptionClick = (selectedOption) => {
      navigate(selectedOption.value);
      onClick();
      setMenuIsOpen(false);
    };

    const customControl = ({ innerProps }) => (
      <div
        {...innerProps}
        onClick={() => navigate("/company-overview")}
        onMouseOver={() => setMenuIsOpen(true)}
        onMouseLeave={() => setMenuIsOpen(false)}
        style={{
          whiteSpace: "nowrap",
          cursor: "pointer",
          display: "none",
        }}
      >
        <Typography
          sx={{ whiteSpace: "nowrap", mr: 2 }}
          fontSize={{ lg: 16, xs: 14 }}
        >
          {" "}
          {t("for_company")}{" "}
        </Typography>
        {menuIsOpen ? (
          <BsChevronUp
            className="uparoow"
            style={{ width: "14px", cursor: "pointer", marginTop: "5px" }}
          />
        ) : (
          <BsChevronDown style={{ width: "14px", cursor: "pointer" }} />
        )}
      </div>
    );

    const customMenu = ({ innerProps, children }) => (
      <div
        {...innerProps}
        onMouseEnter={() => setMenuIsOpen(true)}
        onMouseLeave={() => setMenuIsOpen(false)}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "-42px",
          top: "10px",
        }}
      >
        <div
          style={{
            backgroundColor: "transparent",
            height: "10px",
            width: "20px",
          }}
        >
          {" "}
        </div>
        {children}
      </div>
    );

    return (
      <>
        <ListItem
          id={`menuItem-${headerTitle}`}
          sx={{
            display: headerTitle === t("contact_us") ? "none" : "flex",
            justifyContent: "center",
            position: "relative",
          }}
          onMouseEnter={() => menu && setMenuIsOpen(true)}
          onMouseLeave={() => menu && setMenuIsOpen(false)}
          onClick={() => {
            navigate(routerPath);
            onClick();
          }}
          className="header-menu-items"
        >
          <Typography
            sx={{ ...webStyle.headerNavLink, whiteSpace: "nowrap" }}
            mr={["For Company"].includes(headerTitle) && 1}
            className="sora"
          >
            {headerTitle}
          </Typography>
          {menu &&
            (menuIsOpen ? (
              <BsChevronUp
                className="uparoow"
                style={{ width: "14px", cursor: "pointer", marginTop: "5px" }}
              />
            ) : (
              <BsChevronDown style={{ width: "14px", cursor: "pointer" }} />
            ))}
        </ListItem>
        {
          <Select
            placeholder="For Comapny"
            value={"For Comapny"}
            onChange={(selectedOption) => handleOptionClick(selectedOption)}
            options={lastOptions}
            styles={styles}
            className="basic-single"
            classNamePrefix="select"
            name="severity_picker"
            components={{ Control: customControl, Menu: customMenu }}
            isSearchable={false}
            menuIsOpen={menuIsOpen}
          />
        }
      </>
    );
  };

  const toggleDropdown = () => {
    navigate("/solutions");
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 10) {
        setBgColor("#FFFFFF"); // Change the background color when scrolled more than 10px
      } else {
        setBgColor("transparent"); // Reset to the default color
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOptionClick = (link) => {
    setSelectedOption(link);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(anchorElNav ? null : event.currentTarget);
    setHeaderMenu(headerMenu && null);
  };

  const handleOpenNavMenu1 = (event) => {
    setAnchorElNav(anchorElNav ? null : event.currentTarget);
    setHeaderMenu1(headerMenu1 && null);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleOpenNavMenuHeader = (event) => {
    setHeaderMenu(headerMenu ? null : event.currentTarget);
  };

  const handleOpenNavMenuHeader1 = (event) => {
    setHeaderMenu1(headerMenu1 ? null : event.currentTarget);
  };

  const handleCloseNavMenuHeader = () => {
    setHeaderMenu(null);
  };

  const handleCloseNavMenuHeader1 = () => {
    setHeaderMenu1(null);
  };
  const handleCloseNavMenuHeader2 = () => {
    setHeaderMenu2(null);
    setHeaderMenu(null);
  };

  const handleScroll = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const handleClick = () => {
    document
      .getElementById("dropdowns-menu")
      .classList.add("pointer-events-none");
    setHeading("");
    setSubHeading("");
  };

  const openDropdown = () => {
    setIsOpen(true);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const handleOpenNavMenuHeader2 = (event) => {
    setHeaderMenu2(headerMenu2 ? null : event.currentTarget);
  };

  // const calculateDropdownPosition = () => {
  //     const dropdownButtonRect = dropdownRef.current.getBoundingClientRect();
  //     const dropdownMenu = document.querySelector('.dropdown-menu');
  //     if (dropdownMenu) {
  //         dropdownMenu.style.top = `${dropdownButtonRect.bottom}px`;
  //         dropdownMenu.style.left = `${dropdownButtonRect.left}px`;
  //     }
  // };

  // useEffect(() => {
  //     if (isOpen) {
  //         calculateDropdownPosition();
  //         window.addEventListener('resize', calculateDropdownPosition);

  //         return () => {
  //             window.removeEventListener('resize', calculateDropdownPosition);
  //         };
  //     }
  // }, [isOpen]);

  const handleScrollToComponent = (id) => {
    const element = document.getElementById(id);

    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offsetTop - headerHeight,
        behavior: "smooth",
      });
      return;
    }
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const { SingleValue } = components;

  const ValueOption = (props) => (
    <SingleValue {...props} className="flex items-center justify-between">
      <div>{languages.find((item) => item.value === lngValue).label}</div>
      <GrLanguage />
    </SingleValue>
  );

  const handleChangeLng = (e) => {
    if (i18n) {
      i18next.changeLanguage(e.value);
      localStorage.setItem("language", e.value);
      setLngValue(e.value);
    }
  };

  return (
    <Grid
      container
      py={{ lg: 3, md: 2, xs: 0 }}
      px={{ lg: 0, xs: 1 }}
      width="100vw"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      zIndex="999"
      top="0"
      sx={{ backgroundColor: bgColor }}
      ref={headerRef}
    >
      <Grid item lg={10} xs={12}>
        <Grid
          container
          py={{ lg: 0, sm: 3, xs: 1 }}
          justifyContent="center"
          alignItems="center"
          flexWrap="nowrap"
        >
          <Grid item md={2} sm={6} xs={12}>
            <div className="flex justify-start">
              <Link to="/" onClick={() => handleScroll()}>
                <img
                  draggable="false"
                  src={vitta_logo}
                  className="h-[30px] sm:h-[50px]"
                  alt="vitta_logo"
                />
              </Link>
            </div>
          </Grid>
          <Grid item md={7} xs={0}>
            <Box
              justifyContent="center"
              alignItems="center"
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
            >
              <div
                className="relative inline-block text-left flex justify-center w-full"
                ref={dropdownRef}
              >
                <div onMouseEnter={openDropdown}>
                  <ListItem
                    onClick={toggleDropdown}
                    className="sora flex justify-center relative sm:text-[14px] xl:text-[18px] cursor-pointer font-[500] header-menu-items"
                  >
                    {t("solutions")}{" "}
                    {isOpen ? (
                      <BsChevronUp
                        className="uparoow ml-1"
                        style={{
                          width: "14px",
                          cursor: "pointer",
                          marginTop: "5px",
                        }}
                      />
                    ) : (
                      <BsChevronDown
                        className="ml-1"
                        style={{ width: "14px", cursor: "pointer" }}
                      />
                    )}
                  </ListItem>
                  {isOpen && (
                    <div className="origin-top-left absolute left-[28px] mt-2 w-[600px] rounded-md shadow-lg ring-1 ring-black ring-opacity-5 bg-[#f5f5f5]">
                      <div className="py-1 pt-3">
                        {links.map((category) => (
                          <div key={category.name}>
                            <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-x-4 px-4">
                              {category.sublinks.map((subcategory) => (
                                <div key={subcategory.Head}>
                                  <div className="sora font-medium">
                                    {subcategory.Head}
                                  </div>
                                  <ul className="mt-2 space-y-1">
                                    {subcategory.sublink.map((link) => (
                                      <li
                                        key={link.name}
                                        className="rounded-1 cursor-pointer px-4 py-2 hover:bg-slate-200 hover:text-gray-900"
                                        onClick={() => {
                                          handleScrollToComponent(
                                            link.scrollId
                                          );
                                          setIsOpen(false);
                                          handleOptionClick(link.link);
                                        }}
                                      >
                                        <Link
                                          className="sora text-left w-full py-[2px] my-2 text-sm text-gray-700"
                                          to={link.link}
                                        >
                                          {link.name}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {navLinkItem.map((page, index) => (
                <DropdownMenuItem
                  key={index}
                  menuItem={page}
                  onClick={() => handleScroll()}
                />
              ))}
              <div className="px-[20px] header-menu-items">
                <Select
                  required
                  id="languageSelect"
                  value={
                    languages.find((item) => item.value === lngValue) || ""
                  }
                  name="Message"
                  placeholder="Select Message"
                  onChange={handleChangeLng}
                  options={languages}
                  styles={styles}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                    SingleValue: ValueOption,
                  }}
                  isSearchable={false}
                  instanceId={useId()}
                  aria-labelledby="languageSelect"
                />
              </div>
            </Box>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Box display="flex" justifyContent="end" alignItems="center">
              <div
                className="requestDemoBtnOuter "
                onClick={() => {
                  navigate("/contact-us");
                  handleScroll();
                }}
                style={{ display: screenWidth < 900 ? "none" : "" }}
              >
                <Button className="sora requestDemoBtn pt-1">
                  {t("contact_us")}
                  <img
                    draggable="false"
                    src={arrow}
                    className="w-[9px] sm:w-[12px] ml-[4px]"
                    alt="Arrow_up_small"
                  />
                </Button>
              </div>
              <div style={{ display: screenWidth < 900 ? "" : "none" }}>
                <Select
                  required
                  id="languageSelect"
                  value={
                    languages.find((item) => item.value === lngValue) || ""
                  }
                  name="Message"
                  placeholder="Select Message"
                  onChange={handleChangeLng}
                  options={languages}
                  styles={styles}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                    SingleValue: ValueOption,
                  }}
                  isSearchable={false}
                  instanceId={useId()}
                  aria-labelledby="languageSelect"
                />
              </div>
              <Box
                justifyContent="end"
                sx={{
                  flexGrow: { xs: "unset", md: 1 },
                  display: { xs: "flex", md: "none" },
                }}
              >
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <BiMenu style={{ fontSize: "26px", cursor: "pointer" }} />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  <MenuItem
                    sx={{
                      width: "auto",
                      px: 3,
                      py: 1,
                      fontSize: 14,
                      color: "#141619",
                      fontWeight: 600,
                    }}
                    onClick={(e) => {
                      setIsOpen(!isOpen);
                      handleOpenNavMenuHeader2(e);
                    }}
                    className="sora"
                  >
                    {t("solutions")}
                    <Menu
                      anchorEl={headerMenu2}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      open={Boolean(headerMenu2)}
                      onClose={() => {
                        handleCloseNavMenuHeader2();
                      }}
                    >
                      <div className="py-1">
                        {links.map((category) => (
                          <div key={category.name}>
                            <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-x-4 px-4">
                              <div
                                className="sora font-bold pt-1 pb-4 cursor-pointer"
                                onClick={() => {
                                  navigate("/solutions");
                                  handleCloseNavMenu();
                                }}
                              >
                                {t("solutions")}
                              </div>
                              {category.sublinks.map((subcategory) => (
                                <div key={subcategory.Head}>
                                  <div className="sora font-bold">
                                    {subcategory.Head}
                                  </div>
                                  <ul>
                                    {subcategory.sublink.map((link, index) => (
                                      <MenuItem
                                        key={index}
                                        sx={{
                                          width: "auto",
                                          fontSize: 14,
                                          color: "#141619",
                                          fontWeight: 600,
                                          minHeight: 32,
                                        }}
                                        className="px-2 hover:bg-gray-100 hover:text-gray-900"
                                        onClick={() => {
                                          handleCloseNavMenu();
                                          handleScrollToComponent(
                                            link.scrollId
                                          );
                                        }}
                                      >
                                        <Link
                                          className="sora text-left w-full my-1 text-sm text-gray font-[500]"
                                          to={link.link}
                                        >
                                          {link.name}
                                        </Link>
                                      </MenuItem>
                                    ))}
                                  </ul>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </Menu>
                  </MenuItem>
                  {navLinkItem.map((page, index) => {
                    return (
                      <div key={index}>
                        <MenuItem
                          sx={{
                            width: "auto",
                            px: 3,
                            py: 1,
                            fontSize: 14,
                            color: "#141619",
                            fontWeight: 600,
                          }}
                          onClick={
                            page.headerTitle === "Docs"
                              ? () => {
                                  window.open(
                                    "https://securr.gitbook.io/securr/",
                                    "_blank"
                                  );
                                  handleCloseNavMenu();
                                }
                              : (e) => {
                                  !page.menu && navigate(page.routerPath);
                                  !page.menu && handleCloseNavMenu();
                                  page.menu && handleOpenNavMenuHeader(e);
                                }
                          }
                          className="sora"
                        >
                          {page.headerTitle}
                        </MenuItem>
                        {page?.menu && (
                          <Menu
                            anchorEl={headerMenu}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            open={Boolean(headerMenu)}
                            onClose={() => {
                              handleCloseNavMenuHeader();
                              handleCloseNavMenu();
                            }}
                          >
                            {page?.menu &&
                              page?.menu?.map((menuLink, i) => (
                                <>
                                  <MenuItem
                                    sx={{
                                      width: "auto",
                                      px: 3,
                                      py: 1,
                                      fontSize: 14,
                                      color: "#141619",
                                      fontWeight: 600,
                                    }}
                                    key={i}
                                    onClick={(e) => {
                                      navigate(menuLink.routerPath);
                                      handleCloseNavMenu();
                                      handleCloseNavMenuHeader();
                                      menuLink.menu &&
                                        handleOpenNavMenuHeader1(e);
                                    }}
                                  >
                                    {menuLink.name}
                                  </MenuItem>
                                </>
                              ))}
                          </Menu>
                        )}
                      </div>
                    );
                  })}
                </Menu>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Header;
